// Author YuJiaBei
// Date 2020-12-02 16:57:54

class EmAdmSysLog {
constructor({
        id = null,
        name = '',
        detail = '',
        exception = '',
        type = '',
        method = '',
        parameters = '',
        response = '',
        address = '',
        browser = '',
        responseDuration = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.detail = detail;
    this.exception = exception;
    this.type = type;
    this.method = method;
    this.parameters = parameters;
    this.response = response;
    this.address = address;
    this.browser = browser;
    this.responseDuration = responseDuration;
    this.remark = remark;
}
}

function newEntity() {
return new EmAdmSysLog();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.em.admin.emAdmSysLog.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'detail',
        label: 'label.em.admin.emAdmSysLog.grid.detail',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'exception',
        label: 'label.em.admin.emAdmSysLog.grid.exception',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'type',
        label: 'label.em.admin.emAdmSysLog.grid.type',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'method',
        label: 'label.em.admin.emAdmSysLog.grid.method',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parameters',
        label: 'label.em.admin.emAdmSysLog.grid.parameters',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'response',
        label: 'label.em.admin.emAdmSysLog.grid.response',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'address',
        label: 'label.em.admin.emAdmSysLog.grid.address',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'browser',
        label: 'label.em.admin.emAdmSysLog.grid.browser',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'responseDuration',
        label: 'label.em.admin.emAdmSysLog.grid.responseDuration',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAdmSysLog.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    nameFilter : "",
    detailFilter : "",
    exceptionFilter : "",
    typeFilter : "",
    methodFilter : "",
    parametersFilter : "",
    responseFilter : "",
    addressFilter : "",
    browserFilter : "",
    responseDurationFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.admin.emAdmSysLog.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'detailFilter',
        label: 'label.em.admin.emAdmSysLog.filter.detail',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'exceptionFilter',
        label: 'label.em.admin.emAdmSysLog.filter.exception',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'typeFilter',
        label: 'label.em.admin.emAdmSysLog.filter.type',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'methodFilter',
        label: 'label.em.admin.emAdmSysLog.filter.method',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parametersFilter',
        label: 'label.em.admin.emAdmSysLog.filter.parameters',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'responseFilter',
        label: 'label.em.admin.emAdmSysLog.filter.response',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'addressFilter',
        label: 'label.em.admin.emAdmSysLog.filter.address',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'browserFilter',
        label: 'label.em.admin.emAdmSysLog.filter.browser',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'responseDurationFilter',
        label: 'label.em.admin.emAdmSysLog.filter.responseDuration',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.admin.emAdmSysLog.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'detail',
        label: 'label.em.admin.emAdmSysLog.entity.detail',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'exception',
        label: 'label.em.admin.emAdmSysLog.entity.exception',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'type',
        label: 'label.em.admin.emAdmSysLog.entity.type',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'method',
        label: 'label.em.admin.emAdmSysLog.entity.method',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parameters',
        label: 'label.em.admin.emAdmSysLog.entity.parameters',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'response',
        label: 'label.em.admin.emAdmSysLog.entity.response',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'address',
        label: 'label.em.admin.emAdmSysLog.entity.address',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'browser',
        label: 'label.em.admin.emAdmSysLog.entity.browser',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'responseDuration',
        label: 'label.em.admin.emAdmSysLog.entity.responseDuration',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAdmSysLog.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmAdmSysLog, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
